import { Route } from "react-router-dom";
import { ROUTES } from "../constants/routes/index";
import CollaboratorFactsheet from "../pages/CollaboratorFactsheet";

export const collaboratorFactsheetRoutes = (
    <Route
        path={ROUTES.collaborator_factsheet}
        element={<CollaboratorFactsheet />}
        key="collaborator_factsheet"
    />
);
